import type {FC} from "react";
import type React from "react";
import {useMemo} from "react";
import resolveConfig from "tailwindcss/resolveConfig";

import tailwindConfig from "../../../tailwind.config";
import UserWatchChange from "../components/UserWatchChange";
import {FrontendContext} from "../contexts/Frontend";

import HTTPProvider from "./HTTPProvider";
import UserProvider from "./UserProvider";
import WebSocketProvider from "./WebSocketProvider";

interface Props {
    baseUrl: string;
    children: React.ReactNode;
}

const FrontendProvider: FC<Props> = ({baseUrl = "", children}) => {
    // this function doesn't output the expected type in which we can add extra colors
    const {theme} = resolveConfig(tailwindConfig);

    return (
        <FrontendContext.Provider
            value={useMemo(
                () => ({baseUrl, colors: theme.colors as FrontendContext["colors"]}),
                [baseUrl, theme.colors]
            )}
        >
            <HTTPProvider url={baseUrl}>
                <UserProvider>
                    <WebSocketProvider url={baseUrl}>
                        {children}
                        <UserWatchChange />
                    </WebSocketProvider>
                </UserProvider>
            </HTTPProvider>
        </FrontendContext.Provider>
    );
};

export default FrontendProvider;
